export const NoStartDateMonthLimit = 4;
export const MonthGapLimit = 1;
export const DateFlexibility = 14;
export const MaxBedroomCount = 8;
